import { render, staticRenderFns } from "./imageCarousel.vue?vue&type=template&id=38a8e5ef&"
import script from "./imageCarousel.vue?vue&type=script&lang=js&"
export * from "./imageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38a8e5ef')) {
      api.createRecord('38a8e5ef', component.options)
    } else {
      api.reload('38a8e5ef', component.options)
    }
    module.hot.accept("./imageCarousel.vue?vue&type=template&id=38a8e5ef&", function () {
      api.rerender('38a8e5ef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2cS0i7i8aCvJ2/JS/imageCarousel.vue"
export default component.exports